/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["zh-Hans",[["ä¸å","ä¸å"]],u,[["æ¥","ä¸","äº","ä¸","å","äº","å­"],["å¨æ¥","å¨ä¸","å¨äº","å¨ä¸","å¨å","å¨äº","å¨å­"],["æææ¥","ææä¸","ææäº","ææä¸","ææå","ææäº","ææå­"],["å¨æ¥","å¨ä¸","å¨äº","å¨ä¸","å¨å","å¨äº","å¨å­"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["1æ","2æ","3æ","4æ","5æ","6æ","7æ","8æ","9æ","10æ","11æ","12æ"],["ä¸æ","äºæ","ä¸æ","åæ","äºæ","å­æ","ä¸æ","å«æ","ä¹æ","åæ","åä¸æ","åäºæ"]],u,[["å¬åå","å¬å"]],1,[6,0],["y/M/d","yå¹´Mædæ¥",u,"yå¹´Mædæ¥EEEE"],["HH:mm","HH:mm:ss","z HH:mm:ss","zzzz HH:mm:ss"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","Ã","â°","â","NaN",":"],["#,##0.###","#,##0%","Â¤#,##0.00","#E0"],"CNY","Â¥","äººæ°å¸",{"AUD":["AU$","$"],"BYN":[u,"Ñ."],"CNY":["Â¥"],"ILR":["ILS"],"JPY":["JPÂ¥","Â¥"],"PHP":[u,"â±"],"RUR":[u,"Ñ."],"TWD":["NT$"],"USD":["US$","$"],"XXX":[]},"ltr", plural];
